export class PurchaseOption {
  purchaseTypeId: number
  title: string = '';
  description: string = '';
  remarks: string = '';
  redirectRoute: string = '';
  clickFunction: () => void = () => { };
  // flag to check if it is a redirect or pop up
  isRedirect: boolean = true;
  disabled: boolean = false;
  constructor(
    purchaseTypeId: number = 0,
    title: string = '',
    description: string = '',
    remarks: string = '',
    redirectRoute: string = '',
    isRedirect: boolean = true,
    clickFunction: () => void = () => { }
  ) {
    this.purchaseTypeId = purchaseTypeId
    this.title = title;
    this.description = description;
    this.remarks = remarks;
    this.isRedirect = isRedirect
    this.redirectRoute = redirectRoute;
    this.clickFunction = clickFunction
  }

  setClickFunction(func: () => void) {
    this.clickFunction = func
  }

  setDisabled(value: boolean) {
    this.disabled = value;
  }
}
